import Cookie from '@component/common/src/util/Cookie';

module.exports = function signedInUser() {
  if (Cookie.get('SignedIn') === '1' && Cookie.get('macys_online_uid')) {
    return true;
  }
  return false;
};
